import { ArrowRightCircle, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "@/api";

function fmt(value) {
  if (!value) return "—";
  return new Date(value).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" });
}

export const TransitionsPanel = ({ refreshKey }) => {
  const [data, setData] = useState(null);

  const load = () => api.get("/automations/transitions", { params: { limit: 50 } }).then(({ data: payload }) => setData(payload)).catch(() => {});

  useEffect(() => {
    load();
    const timer = setInterval(load, 15000);
    return () => clearInterval(timer);
  }, [refreshKey]);

  if (!data) return null;

  return (
    <section className="data-panel transitions-panel" data-testid="transitions-panel">
      <div className="panel-heading">
        <div>
          <p className="eyebrow">ENCHAÎNEMENT DES RELANCES</p>
          <h2>Passages automatiques</h2>
        </div>
        <div className="journal-controls">
          <span className="table-count" data-testid="transitions-summary">{data.total_ok} passage(s) au total · dernier cycle : {fmt(data.last_run_at)} · prochain : {data.next_run}</span>
          <button type="button" className="icon-action" onClick={load} aria-label="Actualiser" data-testid="transitions-refresh"><RefreshCw size={16} /></button>
        </div>
      </div>
      <div className="table-wrap">
        <table data-testid="transitions-table">
          <thead><tr><th>Fiche</th><th>De</th><th></th><th>Vers</th><th>E-mail envoyé le</th><th>Délai</th><th>Déplacée le</th><th>Statut</th></tr></thead>
          <tbody>
            {data.items.length === 0 && <tr><td colSpan="8" className="empty-cell" data-testid="transitions-empty">Aucun passage automatique pour le moment.</td></tr>}
            {data.items.map((item) => (
              <tr key={item.id} data-testid={`transition-row-${item.id}`}>
                <td>{item.lead_title || item.lead_id}</td>
                <td>{item.from_step}</td>
                <td><ArrowRightCircle size={14} /></td>
                <td><strong>{item.to_step}</strong></td>
                <td className="mono">{fmt(item.sent_at)}</td>
                <td className="mono">{item.business_days} j ouvré(s)</td>
                <td className="mono">{fmt(item.created_at)}</td>
                <td>
                  <span className={`status-badge ${item.status === "ok" ? "status-termine" : "status-erreur"}`}>{item.status === "ok" ? (item.trigger === "manuel" ? "Déplacée (manuel)" : "Déplacée") : "Échec"}</span>
                  {item.error && <div className="review-reason-inline error"><span>{item.error}</span></div>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
};
